// extracted by mini-css-extract-plugin
export var faqBlock = "styles-module--faqBlock--2YO0E";
export var heading = "styles-module--heading--2y3oa";
export var accordionContainer = "styles-module--accordionContainer--3NUSf";
export var accordion = "styles-module--accordion--zF1lP";
export var accordionItem = "styles-module--accordionItem--1Temm";
export var accordionButton = "styles-module--accordionButton--1YXU9";
export var accordionBodyContainer = "styles-module--accordionBodyContainer--1HsxV";
export var accordionItemBody = "styles-module--accordionItemBody--13gjX";